import { Inject } from '@odinjs/odin';
import Controller, { OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import { BladderIrrigationTerminateAliases, FragmentNames } from '../../../../../codegen';
import BaseController from '../../../../BaseController';
import { AutocompleteAPI, FormAPI} from '@philips-internal/oswald-ui-components';
import TimelineContext from '../../../services/timeline-service';
import { AppearanceOfLiquidType } from '../bladder-irrigation-params';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../../../constants/endpoints';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { DateFilterUtils } from '../../../../../utils/date-filter-utils';
import { ApplicationRoute } from '../../../../../constants/routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import MedicationService from '../../../../../controllers/adep/services/medication-service';
import { Value } from '@philips-internal/oswald-ui-core';
import { CreateGenerateGastherapyChangeResponse } from '../../gastherapy/gastherapy-service';
import { AdminModalsService } from '../../../../../controllers/adep/services/admin-modals-service';
import { MedicineAndSolutionsParams } from '../../medicine-and-solutions/medicine-and-solutions-params';

@Controller({ component: BladderIrrigationTerminateAliases.TERMINATE_BLADDER_IRRIGATION_LAYOUT, fragment: FragmentNames.BLADDER_IRRIGATION_TERMINATE })
export default class BladderIrrigationViewerController extends BaseController {

  @Inject(BladderIrrigationTerminateAliases.FORM_CONTENT)
  private formApi!: FormAPI;

  @Inject(BladderIrrigationTerminateAliases.AUTOCOMPLETE_LIQUID_ASPECT)
  private liquidAscpectAutocompleteApi!: AutocompleteAPI;

  @OnMount(BladderIrrigationTerminateAliases.FORM_CONTENT)
  handleBladderIrrigationFormMount(): void {
    this.formApi.setData({
      currentDateTime: DateFilterUtils.getCurrentDateTimeUtc(),
    })
  }

  @OnSubmit(BladderIrrigationTerminateAliases.FORM_CONTENT)
  handleBladderIrrigationFormSubmit(): void {
    this.terminateBladderIrrigation();
  }

  private terminateBladderIrrigation(): void {
    this.isLoading(true);
    const body = this.getBodyTerminateBladderIrrigation()
    const irrigationSequence = Number(MedicineAndSolutionsParams.params.nrSequenceId)
    this.fetchBladderIrrigation(body, irrigationSequence)
      .then(() => {
        MedicationService.showToast('txt.item-terminate-with-success', ToastLevel.SUCCESS);
        this.isLoading(false);
        this.redirectUserToTimeline();
      }).catch((err) => {
        this.isLoading(false);
        if (err.body?.errors) {
          err?.body?.errors.forEach((message: string) => {
            MedicationService.showToast(message, ToastLevel.WARNING);
          })
          return;
        }
        if (err.body) {
          MedicationService.showToast(err.body, ToastLevel.ERROR);
        }
      })
  }

  private getBodyTerminateBladderIrrigation(): Record<string, Value> {
    const { prescriptionNumber } = TimelineContext.get();
    const { encounterId } = this.historyService.getCurrentRouteParams();
    const currentRecord = this.formApi.getValue();
    const liquidAspectSelected = this.liquidAscpectAutocompleteApi.getValue() as unknown as AppearanceOfLiquidType;

    return {
      amountDrained: currentRecord.drainedVolume,
      amountInfusion: currentRecord.infusedVolume,
      aspectSequence: liquidAspectSelected?.appearanceOfLiquidCode,
      changeDate: currentRecord.currentDateTime,
      encounterId,
      observation: currentRecord.observation,
      prescriptionNumber,
    } as Record<string, Value>
  }

  private redirectUserToTimeline(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const redirectRoute = ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION;
    applicationContext.redirect(redirectRoute, { encounterId, patientId });
    applicationContext.clearNavigationStack();
    AdminModalsService.redirectToTimeline(FragmentNames.BLADDER_IRRIGATION_TERMINATE);
    AdminModalsService.redirectToTimeline(FragmentNames.BLADDER_IRRIGATION_VIEWER);
  }

  private fetchBladderIrrigation(body: Record<string, Value>, irrigationSequence: number): Promise<CreateGenerateGastherapyChangeResponse> {
    return HttpService.post(
      Endpoint.EMAR_POST_TERMINATE_BLADDER_IRRIGATION, { irrigationSequence },
      { body }
    ).then(response => {
      return response.body as CreateGenerateGastherapyChangeResponse;
    });
  }

  private isLoading(state: boolean): void {
    this.formApi.setLoading(state);
  }
}
